"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Utils = void 0;
class Utils {
    constructor() {
        this.getGasData = ({ transactionRequest, overrides }) => {
            const { gasLimit, gasPrice, maxPriorityFeePerGas, maxFeePerGas } = transactionRequest;
            const gasParams = maxPriorityFeePerGas
                ? {
                    gasLimit,
                    maxPriorityFeePerGas,
                    maxFeePerGas
                }
                : {
                    gasLimit,
                    gasPrice
                };
            return overrides ? { ...gasParams, ...overrides } : gasParams;
        };
    }
    async validateNativeBalance({ fromProvider, sender, amount, fromChain }) {
        const balance = BigInt((await fromProvider.getBalance(sender)).toString());
        if (amount > balance) {
            throw new Error(`Insufficient funds for account: ${sender} on chain ${fromChain.chainId}`);
        }
        return {
            isApproved: true,
            message: `User has the expected balance ${amount} of ${fromChain.nativeCurrency.symbol}`
        };
    }
    async validateTokenBalance({ amount, fromTokenContract, sender, fromChain }) {
        const balance = BigInt((await fromTokenContract.balanceOf(sender)).toString());
        if (amount > balance) {
            throw new Error(`Insufficient funds for account: ${sender} on chain ${fromChain.chainId}`);
        }
        return {
            isApproved: true,
            message: `User has the expected balance ${amount} of ${await fromTokenContract.symbol()}`
        };
    }
    async validateAllowance({ amount, fromTokenContract, sender, router }) {
        const allowance = BigInt((await fromTokenContract.allowance(sender, router)).toString());
        return !(amount > allowance);
    }
}
exports.Utils = Utils;
//# sourceMappingURL=utils.js.map